import { useActiveCompany } from 'src/organization/hooks/useActiveCompany';

export const PrivateGuard = ({ element }: { element: JSX.Element }) => {
  const { activeCompany } = useActiveCompany();

  // TODO: Remove this logic from here when all legacy code is removed
  if (!activeCompany) {
    return null;
  }

  return <div className="private">{element}</div>;
};
